<template>
  <div class="movie-item-box">
    <div v-for="(item, index) in list" :key="index" class="movie-item-card" @click="goDetail(item)">
      <!-- 左侧海报 -->
      <div class="movie-poster">
        <img class="poster-img" :src="item.pic" />
        <div class="poster-score" v-if="item.grade">{{ item.grade }}分</div>
        <div v-if="item.versionTypes" class="poster-version">{{ item.versionTypes }}</div>
      </div>
      
      <!-- 右侧信息 -->
      <div class="movie-content">
        <div class="movie-name">{{ item.name }}</div>
        <div class="movie-info-row" v-if="item.filmTypes">
          <span class="info-label">类型:</span>
          <span class="info-value">{{ item.filmTypes }}</span>
        </div>
        <div class="movie-info-row" v-if="item.director">
          <span class="info-label">导演:</span>
          <span class="info-value">{{ item.director }}</span>
        </div>
        <div class="movie-info-row" v-if="item.cast">
          <span class="info-label">主演:</span>
          <span class="info-value text-ellipsis">{{ item.cast }}</span>
        </div>
        <!-- 购票/预售按钮 -->
        <div class="movie-action">
          <div v-if="canBuy(item)" class="buy-btn" @click.stop="goCinema(item)">购票</div>
          <div v-else class="buy-btn presale" @click.stop="goCinema(item)">预售</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MovieItem",
  props: {
    list: {
      type: Array,
      default: () => []
    },
  },
  methods: {
    // 判断是否已上映（可购票）
    canBuy(item) {
      return this.$moment().isAfter(this.$moment(item.publishDate), 'day') || 
             this.$moment().isSame(this.$moment(item.publishDate), 'day');
    },
    
    // 点击卡片进入详情页
    goDetail(val) {
      this.$router.push({
        path: "/MovieDetail",
        query: {
          showbutton: 1,
          item: JSON.stringify(val),
        },
      });
    },
    
    // 点击购票/预售按钮，跳转选择影院
    goCinema(val) {
      this.$router.push({
        path: "/Cinema",
        query: {
          filmId: val.filmId,
          movieName: val.name,
        },
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.movie-item-box {
  background: transparent;
}

.movie-item-card {
  display: flex;
  background: #fff;
  border-radius: 0.8rem;
  padding: 0.8rem;
  margin-bottom: 0.8rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  
  &:active {
    background: #f9f9f9;
  }
  
  &:last-child {
    margin-bottom: 0;
  }
}

.movie-poster {
  width: 5.8rem;
  height: 8rem;
  min-width: 5.8rem;
  border-radius: 0.5rem;
  overflow: hidden;
  position: relative;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.poster-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.poster-score {
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(135deg, #ff6b4a 0%, #ff8a65 100%);
  padding: 0.1rem 0.4rem;
  border-bottom-right-radius: 0.5rem;
  color: #fff;
  font-size: 0.65rem;
  font-weight: 600;
}

.poster-version {
  position: absolute;
  bottom: 0.3rem;
  right: 0.3rem;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  padding: 0.05rem 0.35rem;
  border-radius: 0.2rem;
  font-size: 0.55rem;
  color: #eee;
}

.movie-content {
  flex: 1;
  margin-left: 1rem;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.movie-name {
  font-size: 1.05rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
}

.movie-info-row {
  display: flex;
  font-size: 0.75rem;
  color: #666;
  margin-bottom: 0.35rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.info-label {
  color: #999;
  margin-right: 0.4rem;
  flex-shrink: 0;
}

.info-value {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.movie-action {
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
  padding-top: 0.2rem;
}

.buy-btn {
  padding: 0.35rem 1rem;
  background: linear-gradient(135deg, #ff6b4a 0%, #ff8a65 100%);
  border-radius: 1rem;
  color: #fff;
  font-size: 0.8rem;
  font-weight: 500;
  box-shadow: 0 4px 10px rgba(255, 107, 74, 0.25);
  
  &.presale {
    background: linear-gradient(135deg, #4a9fff 0%, #65b0ff 100%);
    box-shadow: 0 4px 10px rgba(74, 159, 255, 0.25);
  }
}
</style>